export default "__VITE_PUBLIC_ASSET__92341f93__"